module.exports = __webpack_public_path__ + "img/manheim.77758841.svg";